<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4C1 3.44772 1.44772 3 2 3H18C18.5523 3 19 3.44772 19 4C19 4.55228 18.5523 5 18 5H2C1.44772 5 1 4.55228 1 4ZM1 10C1 9.44772 1.44772 9 2 9H18C18.5523 9 19 9.44772 19 10C19 10.5523 18.5523 11 18 11H2C1.44772 11 1 10.5523 1 10ZM1 16C1 15.4477 1.44772 15 2 15H10C10.5523 15 11 15.4477 11 16C11 16.5523 10.5523 17 10 17H2C1.44772 17 1 16.5523 1 16Z" fill="#858E97"/>
    </svg>
</template>

<script>
export default {
    name: 'IconCompare',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
